import api from './client';

export interface Workspace {
  id: string;
  name: string;
  region: string;
  postingServerRegion: string;
  accountCount: number;
  activeCampaigns: number;
  pendingReviews: number;
  teamMembers: string[];
}

export async function getWorkspaces(): Promise<Workspace[]> {
  return api.get('/workspaces');
}

export async function createWorkspace(data: { name: string; region?: string; postingServerRegion?: string }): Promise<Workspace> {
  return api.post('/workspaces', data);
}

export async function updateWorkspace(id: string, data: Partial<Workspace>): Promise<Workspace> {
  return api.patch(`/workspaces/${id}`, data);
}

export async function deleteWorkspace(id: string, password: string): Promise<{ success: boolean }> {
  return api.delete(`/workspaces/${id}`, { password });
}
